import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ModalAddToMyBasket from 'components/Modals/ModalAddToMyBasket/ModalAddToMyBasket';
import ModalAddToCartError from 'components/Modals/ModalAddToCartError/ModalAddToCartError';
import { ProductType } from 'types/ProductPageV2/Products';

export const ADD_TO_CART_STATE = {
  NONE: 'none',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type ADD_TO_CART_STATE = typeof ADD_TO_CART_STATE[keyof typeof ADD_TO_CART_STATE];

type Props = {
  state: ADD_TO_CART_STATE;
  product: ProductType;
  updateState: (state: ADD_TO_CART_STATE) => void;
  isAllProducts?: boolean;
};

export default function AddToCartModal({
  state,
  product,
  updateState,
  isAllProducts = false,
}: Props): JSX.Element | null {
  const { t } = useTranslation();
  const [isHover, setIsHover] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(true);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (state === ADD_TO_CART_STATE.SUCCESS && !isHover) {
      timeoutRef.current = setTimeout(() => setIsOpenModal(false), 3000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [isHover, state, updateState]);

  if (state === ADD_TO_CART_STATE.SUCCESS) {
    return (
      <ModalAddToMyBasket
        isOpen={isOpenModal}
        closeModal={() => updateState(ADD_TO_CART_STATE.NONE)}
        product={product}
        onMouseOver={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        successAddToCartMessage={
          isAllProducts ? t('ITEMS_HAS_BEEN_ADDED_TO_YOUR_BASKET') : undefined
        }
      />
    );
  }

  if (state === ADD_TO_CART_STATE.ERROR) {
    return (
      <ModalAddToCartError
        isOpen={isOpenModal}
        onClose={() => updateState(ADD_TO_CART_STATE.NONE)}
      />
    );
  }

  return null;
}
